import { Attribute } from './types';

export function isAttributeRequired(attr: Pick<Attribute, 'attr'>): boolean {
    if (attr.attr === 'packaging' || attr.attr === 'standardFactoryLeadTime') {
        return false;
    }
    return true;
}
